module.exports = __webpack_public_path__ + "static/img/header.bdd02d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pc/assets/header.png
// module id = jfHu
// module chunks = 36